import { Component, Input, SimpleChanges, ViewChild } from '@angular/core';
import { OfbizList, OfbizForm, RemoteFormData, OfbizListComponent } from '@urbannex/ofbiz-forms';
import { map, Subject, Subscription, takeUntil } from 'rxjs';
import { ComponentConfig, OutGoingLink } from '../../shared/model';
import { Router } from '@angular/router';
import { RelationService } from '../../relation-container/relation.service';
import { UbsComponentStoreService } from '../../ubs-component-store.service';
import { UpdateComponentStoreService } from '../../update-component-store.service';
import { ViewContainersService } from '../../shared/services/view-containers.service';

@Component({
  selector: 'ubs-detail-list-container',
  templateUrl: './detail-list-container.component.html',
  styleUrls: ['./detail-list-container.component.scss']
})
export class DetailListContainerComponent {
  @Input() listForm:OfbizList;
  @Input() addForm:OfbizForm;
  @Input() parameters:any;
  @Input() title:string;
  @Input() appContext:string;
  remoteFormData:RemoteFormData;

  fieldOptions:any;
  listOptions:any = {};
  columnFields:any = {};
  
  viewMode:string = "collapsible";
  refreshSubscription:Subscription;
  refreshList$:boolean;
  outGoingLinks:OutGoingLink[];
  firstRowRead = true;
  
  private readonly destroy$ = new Subject<void>(); 

  readonly listData$ = this.relationService.getSelectedRow().pipe(
      map(data => {
        console.log({ListData:data,Component:"DetailListContainerComponent",Comment:"Mapping ListData"});
        return data;
      })
    )

  @ViewChild(OfbizListComponent) detailList!: OfbizListComponent;

  constructor(
      private componentStore:UbsComponentStoreService,
      private relationService:RelationService,
      private updateComponentStoreService:UpdateComponentStoreService,
      private router:Router,
      private viewContainersService:ViewContainersService) { 
        
        this.componentStore.componentConfig$.pipe(takeUntil(this.destroy$))
        .subscribe((componentConfig:ComponentConfig) => {
          console.log({ComponentConfig:componentConfig});        
            if(componentConfig.outGoingLinks){
              console.log({OutGoingLinks:componentConfig})
              this.outGoingLinks = componentConfig.outGoingLinks;
            }      
        })
    }
  
    ngOnInit(): void {
      this.relationService.getRefreshList()
      .pipe(takeUntil(this.destroy$))
      .subscribe((execute:boolean) => {
        console.log("execute",execute)
        this.refreshList$ = execute;
        console.log({RefreshList:this.refreshList$,Component:"RelationListContainerComponent",Comment:"Getting state from subscription"})
      });
      this.listData$.subscribe((data:any[]) => {
        if(data){
          if(this.firstRowRead){
            this.firstRowRead = false
          }else if(!this.firstRowRead){
            this.updateRemoteFormData(data);
          }
        }
      });
      
    }
  
    ngOnChanges(changes: SimpleChanges): void {
      //Called before any other lifecycle hook. Use it to inject dependencies, but avoid any serious work here.
      //Add '${implements OnChanges}' to the class.
      if(changes["listForm"]){
        console.log({RelationList:this.listForm});
        console.log({findParameters:this.listForm.findParameters});
        if(this.listForm.remoteFormData != undefined && this.listForm.remoteFormData != null){
          this.remoteFormData = this.listForm.remoteFormData;
          console.log({findParameters:this.listForm.findParameters});
          if(this.listForm?.findParameters){
            //this.remoteFormData["parameters"] = {};
            let parameters = {};
            this.listForm.findParameters.forEach(findParameter => {
              console.log(findParameter);
              Object.keys(findParameter).forEach(key => {
                //this.remoteFormData["parameters"][key] = findParameter[key];
                //this.remoteFormData["formData"][key] = findParameter[key];
                parameters[key] = findParameter[key];
              })
            });
            //this.remoteFormData = {...this.remoteFormData,parameters:parameters};
            this.remoteFormData.parameters = parameters;
          }
          console.log("Track RemoteFormData Change",this.remoteFormData);
        }else{
          this.remoteFormData = {
            formData:{
              listType:this.listForm?.listType,
              formName:this.listForm.listFormName,
              formLocation:this.listForm.listFormLocation,
              viewIndex:this.listForm.viewIndex
            },
              endPoint:this.listForm.endPoint
          };
        }
        
        /* if(this.parameters){
          console.log({ParametersRelationList:this.parameters});
          this.remoteFormData.parameters = this.parameters;
        }else if(this.listForm?.findParameters){
          console.log({findParameters:this.listForm.findParameters});
          this.remoteFormData["parameters"] = {};
          this.listForm.findParameters.forEach(findParameter => {
            console.log(findParameter);
            Object.keys(findParameter).forEach(key => {
              this.remoteFormData["parameters"][key] = findParameter[key];
            })
          });
          console.log({findParameters:this.remoteFormData["parameters"]});
        } */
  
  
        this.fieldOptions = this.listForm.fieldFormFields;
  
        this.listOptions.formName = this.listForm.listFormName;
        this.listOptions.entityName = this.listForm.entityName;
        this.listOptions.formLocation = this.listForm.listFormLocation;
        if(this.listForm.viewIndex){
          this.listOptions.viewIndex = this.listForm.viewIndex;
        }
        if(this.listForm.endPoint){
          this.listOptions.endPoint = this.listForm.endPoint;
        }
        if(this.listForm.columnFields){
          this.columnFields = this.listForm.columnFields;
        }
        if(this.listForm.labelColumn){
          this.listOptions.labelColumn = this.listForm.labelColumn;
        }
        if(this.listForm.listType != undefined){
          this.remoteFormData.formData.listType = this.listForm.listType;
        }
        if(this.listForm.target){
          this.listOptions.target = this.listForm.target;
        }
        console.log({RelationList:this.listForm,RemoteFormData:this.remoteFormData,FieldOptions:this.fieldOptions,ListOptions:this.listOptions,ColumnFields:this.columnFields});
        
      }
      if(changes["addForm"]){
        this.listOptions.addForm = this.addForm;
      }
      if(changes["appContext"]){
        this.remoteFormData.appContext = this.appContext;
      }
      if(changes["parameters"]){
        console.log(this.parameters);
      }
    }
  
    handleHyperLinkSelected(e){
      console.log({TrackSelectedValue:e});
      if(this.outGoingLinks){
        console.log({outGoingLinksRelationList:this.outGoingLinks,Incoming:e})
        let outGoingLink = this.outGoingLinks.find(outGoingLink => outGoingLink.target === e.target);
        outGoingLink.targetType = e.targetType;
        outGoingLink.segments.forEach(segment => {
          console.log({Segment:segment})
          if(e.parameters.hasOwnProperty(segment.parameter)){
            outGoingLink.parameters[segment.parameter] = e.parameters[segment.parameter];
            segment.parameter = e.parameters[segment.parameter];
          }  
        });
        outGoingLink.targetType = e.targetType? e.targetType: "";
        outGoingLink.remoteFormData = e.remoteFormData? e.remoteFormData:null;
        //outGoingLink.parameters = e.parameters;
        console.log({outGoingLink:outGoingLink});
        this.updateComponentStoreService.setOutGoingLink(outGoingLink);
        //this.componentStore.updateOutGoingLink(outGoingLink);
        if(outGoingLink.targetType == "intra-app"){
          let url = "admin/pms";
          outGoingLink.segments.forEach(segment => {
            url = url+"/"+segment.pathElement+"/"+segment.parameter
          })
          this.router.navigateByUrl(url, { skipLocationChange: false });
          console.log(outGoingLink);
        }
        //this.componentStore.updateOutGoingLink(outGoingLink);
        /* const urlSegmentGroup: Observable<string> = this.route.url.pipe(map(segments => segments.join('')));
        urlSegmentGroup.subscribe(data => {
          console.log(data)
        }); */
      } 
  
    }
    /**
     * Function gets data from list and notifies header via ViewContainersService
     * Data is only sent if getList return a list successfully
     * Data is used in breadCrumb creation
     * @param data : RemoteFormData
     */
    handleListSucessNotify(data:any):void{
      console.log("successData in ListContainerComponent",data.rows);
      //this.viewContainersService.setNotifiedSuccess(data);
      //Set the first row as selected
      let rows:any[] = data.rows;
      if(rows.length > 0){
        let firstRow = rows[0];
        console.log({FirstRow:firstRow});
        //this.relationService.setSelectedRow(firstRow);      
      }
    }

    updateRemoteFormData(rowData:any[]){
      console.log("Should be true",this.firstRowRead,rowData);
      if(this.listForm.remoteFormData != undefined && this.listForm.remoteFormData != null){
        this.remoteFormData = this.listForm.remoteFormData;
        console.log({findParameters:this.listForm.findParameters});
        let parameters = {};
        let parameterKeys = [];
        this.listForm.findParameters.forEach(parameter => {
          Object.keys(parameter).forEach((key:string) => parameterKeys.push(key))
        })
        parameterKeys.forEach(key => {
          for(const rowItem of rowData){
            if(rowItem.hasOwnProperty(key)){
              parameters[key] = rowItem[key]
            }
          }
          /* let usedKey = rowData.find(rowItem => key == rowItem[key]);
          if(usedKey){
            parameters[key] = usedKey[key];
          } */
        })
        
        //this.remoteFormData.parameters = parameters;
        this.remoteFormData = {...this.remoteFormData,parameters:parameters}
        console.log(parameterKeys,parameters,this.remoteFormData);
        this.detailList.getList(this.remoteFormData);
        /* rowData.forEach(parameter => {

        })
        if(this.listForm?.findParameters){
          let parameters = {};
          this.listForm.findParameters.forEach(findParameter => {
            console.log(findParameter);
            Object.keys(findParameter).forEach(key => {
              parameters[key] = findParameter[key];
            })
          });
          
          this.remoteFormData.parameters = parameters;
        }
        console.log("Track RemoteFormData Change",this.remoteFormData); */
      }
    }
  
  
    rowSelected(e){
      //Convert row data object into an array of objects
      const rowObjects = Object.entries(e.data).map(([key, value]) => ({ [key]: value }));
      this.relationService.setSelectedRow(rowObjects);
    }
  
    ngOnDestroy() {
      this.destroy$.next();
      this.destroy$.complete();
      //this.refreshSubscription.unsubscribe();
    }
  
}
